import { lazy } from 'react'
import type { LazyExoticComponent } from 'react'
import type { Permission } from '../types/permissions'
import { Resource, Action } from '../types/permissions'

const isAuditLogsEnabled = process.env.REACT_APP_AUDIT_LOGS_FLAG === 'true'

export interface RouteDefinition {
  path: string
  component: LazyExoticComponent<() => React.JSX.Element>
  permission?: Permission
}

export const privateRoutes: RouteDefinition[] = [
  {
    path: '/dashboard',
    component: lazy(() => import('../pages/dashboard')),
    permission: `${Resource.Dashboard}:${Action.View}`,
  },
  {
    path: '/organisations',
    component: lazy(() => import('../pages/organisations')),
    permission: `${Resource.Organisations}:${Action.View}`,
  },
  {
    path: '/organisations/:id',
    component: lazy(() => import('../pages/organisations/detail')),
    permission: `${Resource.Organisations}:${Action.View}`,
  },
  {
    path: '/organisations/:id/edit',
    component: lazy(() => import('../pages/organisations/detail')),
    permission: `${Resource.Organisations}:${Action.Update}`,
  },
  {
    path: '/plans',
    component: lazy(() => import('../pages/plans')),
    permission: `${Resource.Plans}:${Action.View}`,
  },
  {
    path: '/plans/:planId/edit',
    component: lazy(() => import('../pages/plans/edit-plan')),
    permission: `${Resource.Plans}:${Action.Update}`,
  },
  {
    path: '/billing',
    component: lazy(() => import('../pages/billing')),
    permission: `${Resource.Billing}:${Action.View}`,
  },
  {
    path: '/feature-flags',
    component: lazy(() => import('../pages/feature-flags')),
    permission: `${Resource.FeatureFlags}:${Action.View}`,
  },
  {
    path: '/notifications',
    component: lazy(() => import('../pages/notifications')),
    permission: `${Resource.Notifications}:${Action.View}`,
  },
  {
    path: '/usage',
    component: lazy(() => import('../pages/usage')),
    permission: `${Resource.Usage}:${Action.View}`,
  },
  {
    path: '/analytics',
    component: lazy(() => import('../pages/analytics')),
    permission: `${Resource.Analytics}:${Action.View}`,
  },
  {
    path: '/upgrade-ops',
    component: lazy(() => import('../pages/upgrade-ops')),
    permission: `${Resource.UpgradeOps}:${Action.View}`,
  },
  {
    path: '/roles',
    component: lazy(() => import('../pages/roles')),
    permission: `${Resource.Roles}:${Action.View}`,
  },
  ...(isAuditLogsEnabled
    ? [
        {
          path: '/audit-logs',
          component: lazy(() => import('../pages/auditLogs')),
          permission: `${Resource.AuditLogs}:${Action.View}` as Permission,
        },
      ]
    : []),
  {
    path: '/security',
    component: lazy(() => import('../pages/security')),
    permission: `${Resource.Security}:${Action.View}`,
  },
  {
    path: '/user-management',
    component: lazy(() => import('../pages/user-management')),
    permission: `${Resource.Users}:${Action.View}`,
  },
  {
    path: '/role-management',
    component: lazy(() => import('../pages/role-management')),
    permission: `${Resource.Roles}:${Action.View}`,
  },
]
